export enum ManualAccommodationMarketType {
    ALL = 'ALL',
    BY_CREATED_MARKET = 'BY_CREATED_MARKET',
    BY_SPECIFIC_MARKET = 'BY_SPECIFIC_MARKET',
}